import { Body } from '@/components/organisms/Admin/Leveling/Success/Body'

export function SuccessLevelingPage() {
	return (
		<div className='flex flex-col'>
			<Body />
		</div>
	)
}
